import PaymentReturn from './PaymentReturn';

export default PaymentReturn;
